import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'
import querystring from 'querystring'

require('./../../security/interceptors')

// const totalReceivedMonth = (objectQueryString) => {
//     let query = querystring.stringify(objectQueryString)
//     return api.get(`/messages/total-received-month?${query}`)
//         .then(response => {
//             return response.data
//         })
//         .catch(error => {
//             return errorCatch(error, 'Não foi possível carregar o total de recebimentos no mês')
//         })
// }

// const totalSendMonth = (objectQueryString) => {
//     let query = querystring.stringify(objectQueryString)
//     return api.get(`/messages/total-send-month?${query}`)
//         .then(response => {
//             return response.data
//         })
//         .catch(error => {
//             return errorCatch(error, 'Não foi possível carregar o total de envios no mês')
//         })
// }

const total = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/reports/total?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a empresa')
        })
}

export default {
    total
    // totalReceivedMonth,
    // totalSendMonth
}
